import globalEventBus from 'toxilibs/event_bus_queued.js'
import getUrlParams from 'toxilibs/url_params.js'
import JsonSynchronizer from 'toxilibs/json_synchronizer.js'
import $ from 'jquery'

let synchronizer = new JsonSynchronizer({
    localStoragePrefix: 'compute_it_hour_of_code'
})

let urlParams = getUrlParams()

let timeBeforeShowLink = 3600 * 1000
let startedTime = synchronizer.getKey('startedTime')

function init () {
    addBeginToxicodeImage()

    let now = Date.now()

    if (!startedTime) {
        startedTime = now
        synchronizer.updateKey('startedTime', startedTime)
    }

    setTimeout(showLink, timeBeforeShowLink - (now - startedTime))
}



function addBeginToxicodeImage () {
    let image = urlParams.progression === 'python' ? 'begin_toxicode_compute2' : 'begin_toxicode_compute'
    $('body').prepend('<img src="//code.org/api/hour/' + image + '.png">')
}



function hideLink () {
    let now = Date.now()
    if (startedTime + timeBeforeShowLink > now) {
        $('#hour_of_code_back').hide()
    }
}



function showLink () {
    $('#hour_of_code_back').show()
}



if ('hour-of-code' in urlParams) {
    globalEventBus.on('game ended', showLink)

    globalEventBus.on('end page hidden', hideLink)

    globalEventBus.on('user wants to erase all progression', function () {
        synchronizer.clearLocal()
    })

    init()
}
